module.exports = __webpack_public_path__ + "static/img/21.f188e752.png";